import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";

import commonStyle from "../../content/CommonStyles.module.css";
import { systemCurrencies } from "../../../Utils/Utils";
import { InputText } from "primereact/inputtext";

const DiscountInput = ({formik, paramName, isDisabled, isMobile}) => {

    const addDiscountHandler = () => {
        const discount = [
            ...formik.values?.[paramName],
            { currency: "UAH", amount: 0 }
        ]
        formik.setFieldValue(paramName, discount);
    }

    const handleParameterChange = (index, value, parameter, array) => {
        const obj = [...formik.values[array]];
        obj[index][parameter] = value;
        formik.setFieldValue(array, obj);
    };

    const deleteObjFromArray = (index, array) => {
        const newArray = formik.values[array];
        newArray.splice(index, 1);
        formik.setFieldValue(array, newArray);
    }

    return (<>
        <div className={`${commonStyle.formInput} mt-4`}>
            <div className="p-inputgroup">
                <span className="p-inputgroup-addon w-full flex justify-content-start">Знижка</span>
                <Button
                    icon="pi pi-plus"
                    className={commonStyle.addButton}
                    severity="success"
                    tooltip="Додати знижку"
                    disabled={isDisabled}
                    type="button"
                    onClick={() => addDiscountHandler()}
                />
            </div>
        </div>
        {formik.values?.[paramName].map((currencyAmount, index) => (
            <div key={index} className={`${commonStyle.formInput} ${commonStyle.marginBottom} ${!isMobile ? "" : "w-11"}`}>
                <div className="p-inputgroup flex-1">
                    <span className={`${commonStyle.currencySpan} p-inputgroup-addon`}>
                        <Dropdown
                            disabled={isDisabled}
                            className={`${commonStyle.currencyDropDown} w-full`}
                            value={currencyAmount.currency}
                            onChange={e => handleParameterChange(index, e.value, "currency", paramName)}
                            options={systemCurrencies}
                        />
                    </span>
                    <InputText
                        onChange={e => handleParameterChange(index, e.target.value, "amount", paramName)}
                        disabled={isDisabled}
                        name="amount"
                        value={currencyAmount.amount}
                        className={formik.errors.price && formik.touched.price ? 'p-invalid' : ''}
                    />
                    <Button
                        icon="pi pi-trash"
                        className={commonStyle.deleteButton}
                        severity="danger"
                        tooltip="Видалити знижку"
                        disabled={isDisabled}
                        type="button"
                        onClick={() => deleteObjFromArray(index, paramName)}
                    />
                </div>
            </div>))
        }
    </>
    )
};

export default DiscountInput;